module.exports = __webpack_public_path__ + "img/prol_laterale_dx.55fdb7ac.png";